import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { userKeys } from '../../cache-keys/userKeys';
import { lock_api } from '@axo/shared/data-access/api';
import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { applicationKeys } from '../../cache-keys/applicationKeys';

export function useLockApplication() {
  const { state } = useContext(DataAccessContext);
  const client = useQueryClient();
  const api = useAPI();

  return useMutation(
    ({
      marketCountry,
      applicationID,
    }: {
      marketCountry: string;
      applicationID: string;
    }) =>
      lock_api.createLock(api)(
        applicationID,
        state.user.clientID,
        marketCountry
      ),
    {
      onSuccess: (_, { marketCountry, applicationID }) =>
        Promise.all([
          client.invalidateQueries(
            userKeys.lockedApplications({
              user: state.user.clientID,
              country: marketCountry,
            })
          ),
          client.invalidateQueries(
            applicationKeys.locks({
              applicationID,
            })
          ),
        ]),
    }
  );
}
